import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export default React.forwardRef((props, ref) => {
    React.useImperativeHandle(ref, () => ({
        getContent: () => ({
            headers: [],
            records: [],
        }),
    }), []);
    return _jsx(_Fragment, { children: props.records.map((record, idx) => _jsx("div", { dangerouslySetInnerHTML: { '__html': record } }, idx)) });
});
